<script>
import { mapGetters } from 'vuex'
export default {
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
	},
	props: {
		canTakeEvaluation: {
			type: Boolean
		},
		tries: {
			type: Number
		},
		points: {
			type: Number
		},
		completed: {
			type: Boolean
		},
		activity: {
			type: Object
		}
	},

	data() {
		return {
			json_fields: {
				'_': 'pregunta',
				'__': 'respuesta',
			},
			json_meta: [
				[
					{
						'key': 'charset',
						'value': 'utf-8'
					}
				]
			],
		}
	},

	computed: {
		...mapGetters({
			userId: 'auth/userId',
			activityById: 'activities/byId',
			userName: 'auth/userName',
			userCode: 'auth/userCode'
		})
	},

	methods: {
		excelData() {
			let vm = this
			let activity = vm.activity
			let results = activity.evaluation.results
			let data  = [
				{
					pregunta: `Resultados ${activity.title}`,
					respuesta: `Participante: ${vm.userName} Código: ${vm.userCode}`,
				},
				{
					pregunta: '',
					respuesta: '',
				},
				{
					pregunta: `Puntos Obtenidos: ${activity.evaluationPoints}`,
					respuesta: '',
				},
				{
					pregunta: `Intentos: ${activity.evaluationTries}`,
					respuesta: '',
				},
				{
					pregunta: '',
					respuesta: '',
				},
				
				
			]

			results.forEach((r, index) => {
				let respuesta = r.options.find(o => o.id == r.resolve)
				data.push({
					pregunta: `${index + 1} ${r.title}`,
					respuesta: `${r.assert ? '✅' : '❌'} ${respuesta ? respuesta.text : '(participante no selecciono)'}`
				})
			});
			this.downloadExcel({
				name: `${this.userName}_${this.userCode}_Evaluacion_${this.activity.title}`,
				fields: [{sheetid:'One',header:false}],
				data: [data]
			})
		},
		repeatActivity() {
			let activity = this.activityById(Number(this.$route.params.activity))
			let module = this.$route.params.module
			this.resetActivity()
			this.$router.push({name: 'formation-activity', params: {activity: activity.activityId, module}})
		},

		resetActivity() {
			let activity = this.activityById(Number(this.$route.params.activity))
			let module = this.$route.params.module

			let name = this.userId + activity.activityId + activity.url
			delete localStorage[name]

		}
	},

}
</script>
<template>
	<div class="wrapper">
		<div v-if="!completed || points < 80">
			<div v-if="tries === 1" >
				<img @click="$emit('start')" class="avatar" src="../../assets/svg/trie-08.svg" alt="">
				<button @click="$emit('start')" class="quiz__nav ml-5">
					<span>Tomar segunda oportunidad</span>
				</button>
			</div>
			<div v-if="tries === 2">
				<img class="avatar" src="../../assets/svg/repeat-08.svg" alt="">
				<button  @click="$emit('start')" class="quiz__nav ml-5">
					<span>Repetir trivia</span>
				</button>
			</div>
			<div v-if="tries > 2">
				<img class="avatar" src="../../assets/svg/fail-08.svg" alt="">
				<div class="d-flex quiz__footer">
					<button @click="excelData" class="btn btn-primary btn-rounded ml-2">
						<span>Descargar Resultados <i class="fa fa-download" aria-hidden="true"></i></span> 
					</button>
					<button @click="goNext(Number($route.params.activity))" class="btn btn-primary btn-rounded ml-5">
						<span>Siguiente actividad</span>
					</button>
					<!-- <export-excel 
							class="btn btn-primary btn-rounded  mx-2"
							:data="excelData()"
							:fields="json_fields"
							type="xls"
							:name="`${userName}_${userCode}_Evaluacion_${activity.title}.xls`">
							Descargar Resultados 
							<i class="fa fa-download" aria-hidden="true"></i>
					</export-excel> -->
				</div>
			</div>
		</div>
		<div v-else>
			<img class="avatar" src="../../assets/svg/completed-15.svg" alt="">
			<div class="d-flex quiz__footer">
				<button @click="excelData" class="btn btn-primary btn-rounded ml-2">
					<span>Descargar Resultados <i class="fa fa-download" aria-hidden="true"></i></span> 
				</button>
				<button @click="goNext(Number($route.params.activity))" class="btn btn-primary btn-rounded ml-5">
					<span>Siguiente actividad</span>
				</button>
				<!-- <export-excel 
						class="btn btn-primary btn-rounded  mx-2"
						:data="excelData()"
						:fields="json_fields"
						type="xls"
						:name="`${userName}_${userCode}_Evaluacion_${activity.title}.xls`">
						Descargar Resultados 
						<i class="fa fa-download" aria-hidden="true"></i>
				</export-excel> -->
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.wrapper{
	background-image: url('../../assets/img/evaluations/bg_03.png');
	background-attachment: fixed;
	background-size: cover;
	position: relative;
	padding: 1em;
}

.avatar{
	max-height: 80vh;
	position: absolute;
	bottom: 0;
}
.quiz__next{
	position: absolute;
	bottom: 5%;
	left: 50%;
	transform: translateX(-50%);
}
.quiz{
	&__footer{
		width: 100%;
		display: flex;
		justify-content: center;
		position: absolute;
		bottom: 0;
		left: 0;
	}
	&__nav{
		border: 0;
		padding: 0;
		height: 50px;
		border-radius: 50px;
		white-space: nowrap;
		padding: 0 1rem;
		text-transform: uppercase;
		font-weight: 700;
		position: absolute;
		bottom: 5%;
		left: 50%;
		transform: translateX(-50%);
		background-color: #2DCCCD;
		cursor: pointer;
		color: #000;
		text-decoration: none !important;
		outline: none !important;
		span{
			line-height: 3em;
		}
		img{
			width: 40px;
		}
		&:hover{
			background-color: darken($color: #F8CD51, $amount: 5);
		}
	}
}
</style>